export default {"src":"/_next/static/media/infinity.15513351.svg","height":19,"width":38};